"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOpenApi3Documentation = void 0;
var tslib_1 = require("tslib");
var parseOpenApi3Documentation_1 = require("./parseOpenApi3Documentation");
Object.defineProperty(exports, "parseOpenApi3Documentation", { enumerable: true, get: function () { return tslib_1.__importDefault(parseOpenApi3Documentation_1).default; } });
tslib_1.__exportStar(require("./parseOpenApi3Documentation"), exports);
//# sourceMappingURL=index.js.map